import FilterPanel from "components/partials/filter-panel/filter-panel";

import { PROGRAM_TYPE_FILTER_OPTIONS } from "containers/admin/clients/client/campaign-templates-page/campaign-template.constants";

import type { FiltersListProps, FiltersStateOnTable } from "types/filters";
import type { FiltersToApplyOnCampaignTemplatesPage } from "containers/admin/clients/client/campaign-templates-page/campaign-templates-page.types";

const filtersToDisplay: FiltersListProps[] = [
  {
    title: "Program type",
    filterId: "programType",
    options: PROGRAM_TYPE_FILTER_OPTIONS,
  },
];

const FiltersOnCampaignTemplatesTable = ({
  filtersToApply,
  setFiltersToApply,
}: FiltersStateOnTable<FiltersToApplyOnCampaignTemplatesPage>) => {
  const handleFilterChange = (filter: { filterId: string }, option: { name: string }) => {
    const { filterId } = filter;

    if (!(filterId in filtersToApply)) {
      return;
    }

    const filterKey = filterId as keyof FiltersToApplyOnCampaignTemplatesPage;
    const currentValues = (filtersToApply[filterKey] as string[] | undefined) ?? [];
    const isSelected = currentValues.includes(option.name);

    setFiltersToApply({
      ...filtersToApply,
      [filterKey]: isSelected
        ? currentValues.filter((item) => item !== option.name)
        : [...currentValues, option.name],
    });
  };

  return (
    <FilterPanel
      filters={filtersToDisplay}
      currentFilters={filtersToApply}
      onFilterChange={handleFilterChange}
      triggerTestId="campaign-template-filters-button"
    />
  );
};

export default FiltersOnCampaignTemplatesTable;
